import orders from './orders/reducer';
import products from './products/reducer';
import settings from './settings/reducer';

export default {
  orders,
  products,
  settings,
};


// WEBPACK FOOTER //
// ./src/redux/reducers.js